/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Offline_Instruction_3Inputs */

const en_login_offline_instruction_3 = /** @type {(inputs: Login_Offline_Instruction_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login using your email and password`)
};

const fr_login_offline_instruction_3 = /** @type {(inputs: Login_Offline_Instruction_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectez-vous avec votre email et mot de passe`)
};

const de_login_offline_instruction_3 = /** @type {(inputs: Login_Offline_Instruction_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melden Sie sich mit Ihrer E-Mail-Adresse und Ihrem Passwort an.`)
};

const it_login_offline_instruction_3 = /** @type {(inputs: Login_Offline_Instruction_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi utilizzando la tua email e password`)
};

const ru_login_offline_instruction_3 = /** @type {(inputs: Login_Offline_Instruction_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войдите, используя свой адрес электронной почты и пароль.`)
};

const es_login_offline_instruction_3 = /** @type {(inputs: Login_Offline_Instruction_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicie sesión con su correo electrónico y contraseña`)
};

const zh_cn2_login_offline_instruction_3 = /** @type {(inputs: Login_Offline_Instruction_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用您的电子邮件和密码登录`)
};

const ja_login_offline_instruction_3 = /** @type {(inputs: Login_Offline_Instruction_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールアドレスとパスワードを使用してログインしてください`)
};

const hi_login_offline_instruction_3 = /** @type {(inputs: Login_Offline_Instruction_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपने ईमेल और पासवर्ड का उपयोग करके लॉग इन करें`)
};

const pt_pt2_login_offline_instruction_3 = /** @type {(inputs: Login_Offline_Instruction_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faça login usando seu e-mail e senha.`)
};

/**
* | output |
* | --- |
* | "Login using your email and password" |
*
* @param {Login_Offline_Instruction_3Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_instruction_3 = /** @type {((inputs?: Login_Offline_Instruction_3Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Instruction_3Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_offline_instruction_3(inputs)
	if (locale === "de") return de_login_offline_instruction_3(inputs)
	if (locale === "it") return it_login_offline_instruction_3(inputs)
	if (locale === "ru") return ru_login_offline_instruction_3(inputs)
	if (locale === "es") return es_login_offline_instruction_3(inputs)
	if (locale === "zh-CN") return zh_cn2_login_offline_instruction_3(inputs)
	if (locale === "ja") return ja_login_offline_instruction_3(inputs)
	if (locale === "hi") return hi_login_offline_instruction_3(inputs)
	if (locale === "pt-PT") return pt_pt2_login_offline_instruction_3(inputs)
	return en_login_offline_instruction_3(inputs)
});